import { AxiosError } from 'axios'

import consoleMessage from 'shared/utils/helpers/consoleMessage'
import isAxiosError from 'shared/utils/helpers/isAxiosError'
import { httpClient } from 'shared/lib'

import { FetchTireParamsResults, TireParamsPayload } from './types'

export function fetchSearchFilters(categoryUuid: string, payload?: TireParamsPayload): Promise<FetchTireParamsResults> {
   let errMessage

   return httpClient
      .post(`categories/${categoryUuid}/filters`, payload)
      .then((res) => {
         if (res.data) {
            return res.data
         }
         throw new Error('No data in request')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('TIRE PARAMS fetchTireParams service', errMessage, 'error')
         throw error
      })
}
